import { Component } from '@angular/core';
import { COPYS } from '@app/constants';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
})
export class LoadingComponent {
  keepMovingText = COPYS.KeepMoving;
}
